<!-- content begin -->
<div id="content" class="no-bottom no-top">
  <div id="top"></div>



  <!-- section begin -->
  <section id="section-intro" class="full-height relative owl-slide-wrapper text-light no-top no-bottom"
    data-bgimage="url(assets/images/background/9.jpg)" data-stellar-background-ratio=".2">
    <div class="overlay-bg t50">

      <!-- <div class="center-y relative">
                <div class="container">
                    <div class="row">
                        <div class="col-md-8">
                            <div class="spacer-double d-block d-sm-none d-md-block"></div>
                            <h3>National Instructional Media Institute</h3>
                            <h1 class="big b">recruitment portal </h1>
                            <div class="spacer-single"></div>
                            <a href="#" class="btn-custom">Learn more</a>
                        </div>
                    </div>
                </div>
            </div> -->

    </div>

    <a href="#section-services" class="scroll-to">
      <span class="mouse">
        <span class="scroll"></span>
      </span>
    </a>
  </section>



  <!-- section begin -->
  <section id="section-services" class="cus_pad_empty">
    <div class="container">

      <div class="row align-items-center">
        <div class="col-md-12">
          <div class="row sequence">
            <div class="col-md-12 sq-item wow sq-item wow">
              <div class="feature-box style-2 left cus_ft_box">
                <div class="text">
                  <span routerLink="/notification" onmouseover="mar.stop();" onmouseout="mar.start();"
                    style="position: absolute; background: linear-gradient(to right, #eb3349, #f45c43); padding: 0px 10px; color: #fff; border-radius: 5px; font-size: 15px; z-index: 1; top: 10px;">Notification </span>
                                       
                    <marquee id="mar" style="font-size: 18px; color: #000;" onmouseover="mar.stop();" onmouseout="mar.start();" > 

                      <!-- <span *ngFor="let service of cls_marquee;">  {{service.title}} {{service.description}} <a class="notifi_btn" target="_blank"
                        href="{{service.url}}">{{service.button_name}}</a> | </span> -->

                        <!-- JVC Practical Exam will be conducted on 16th November 2021 -->
                        <!-- Due to administrative reasons, the further process of engagement of 78 Consultants(Technical and IT Consultant) of non-training profile at DGT Hqrs. and RDSDEs is cancelled <a href="assets/pdf/OM Tech and IT consultant cancellation.pdf" target="_blank" style="background: linear-gradient(to right, #eb3349, #f45c43); padding: 3px 10px; color: #fff; border-radius: 5px; font-size: 15px;">Click Here </a>| JC - Revised waiting, list candidates  <a href="assets/pdf/JC waiting  list candidates.pdf" target="_blank" style="background: linear-gradient(to right, #eb3349, #f45c43); padding: 3px 10px; color: #fff; border-radius: 5px; font-size: 15px;">Click Here </a> | Selected Candidates List for JVC  <a href="assets/pdf/JVC Selected List.pdf" target="_blank" style="background: linear-gradient(to right, #eb3349, #f45c43); padding: 3px 10px; color: #fff; border-radius: 5px; font-size: 15px;">Click Here </a> | Selected Candidates List for Consultant IT <a href="assets/pdf/Consultant - IT Support - Final (07.01.2022).pdf" target="_blank" style="background: linear-gradient(to right, #eb3349, #f45c43); padding: 3px 10px; color: #fff; border-radius: 5px; font-size: 15px;">Click Here </a> | Selected Candidates List for Consultant Technical Support <a href="assets/pdf/Consultant%20-%20Technical%20Support%20(Final)%20-%2007.01.2022%20(1).pdf" target="_blank" style="background: linear-gradient(to right, #eb3349, #f45c43); padding: 3px 10px; color: #fff; border-radius: 5px; font-size: 15px;">Click Here </a> -->
                        <!-- The location of the vacancies indicated are tentative only. The final posting locations may vary from time to time subject to the requirement of the Organisation | Candidates attending the practical exam for JVC, Consultant IT & Technical support should bring all the relevant original certificates for verification. | The practical exam  date for Consultant IT and Consultant Technical Support on 20th November 2021 -->
                        JC Recruitment has been postponed. Further communication will be intimated shortly. 
                    </marquee>
                   <!-- | kind Attention JC Practical Shortlisted Candidates - Please Upload your CITS Certificate before 5PM 23-09-2021 | Practical examination date for JVC, Con(IT) and Con(Technical) will be announced shortly. Pleace keep watching the portal at regular intervals | CBT Exam Result for Junior Vocational Consultants, Consultants (IT Support ) and Consultants (Technical Support ) Shortlisted Candidates List for Practical Exam <a
                    href="http://nimiprojects.in/recruitment/login.php" target="_blank"
                    style="background: linear-gradient(to right, #eb3349, #f45c43); padding: 3px 10px; color: #fff; border-radius: 5px; font-size: 18px;">Click
                    Here </a>-->
                </div>

               

              </div>
            </div>
          </div>
        </div>


      </div>


    </div>
  </section>




  <!-- section close -->
  <div class="row notifi_main ">
    <div class="col-md-12">
      <h2>
        Recruitment Portal
      </h2>
      <p class="descrip_cls">A common job portal for DGT | NSTI | RDSDE | CSTARI | NIMI | SANKALP </p>
    </div>
  </div>








  <!-- <div class="container">
    <h2 class="process_cls">Current Openings Under DGT</h2>
    <hr style="border-top: solid 1px #F56B55;">
  </div> -->


  <!-- section begin -->
  <section id="section-services" style="padding: 0px;">
    <div class="container">

      <div class="row align-items-center">
        <div class="col-md-12">
          <div class="row sequence">
            <!-- feature box begin -->
            <!-- <div class="col-md-6 mb40 sq-item wow sq-item wow">
                <div class="feature-box style-2 left">
                  <i routerLink="/jconsultant" class="fa fa-user"></i>
                  <div class="text">
                    <h3 style="cursor: pointer;" routerLink="/jconsultant">Junior Consultant - Training </h3>
                    Junior Consultant (Training) will be engaged at NSTI's for imparting training in theory and practical
                    related to their subject. JC at CSTARI will be engaged in curriculum development activities .
                  </div>
                </div>
              </div> -->
            <!-- feature box close -->


            <!-- feature box begin -->
            <!-- <div class="col-md-6 feature-box mb40 sq-item wow">
              <div class="feature-box style-2 left">
                <i routerLink="/ContentWriterdgt" class="fa fa-user"></i>
                <div class="text">
                  <h3 style="cursor: pointer;" routerLink="/ContentWriterdgt">Content Writer
                  </h3>
                  Content Writer for DGT


                </div>
              </div>
            </div> -->
            <!-- feature box close -->



            <!-- feature box begin -->
            <!-- <div class="col-md-6 feature-box mb40 sq-item wow">
                <div class="feature-box style-2 left">
                  <i routerLink="/engagingconult" class="fa fa-user"></i>
                  <div class="text">
                    <h3 style="cursor: pointer;" routerLink="/engagingconult">Consultants (IT Support )
                    </h3>
                    The engagement of Non- Training Profile Consultants (IT Support ) to be engaged in RDSDEs and DGT
                    HQRs.


                  </div>
                </div>
              </div> -->
            <!-- feature box close -->

            <!-- feature box begin -->
            <!-- <div class="col-md-6 feature-box mb40 sq-item wow">
                <div class="feature-box style-2 left">
                  <i routerLink="/engagingtech" class="fa fa-user"></i>
                  <div class="text">
                    <h3 style="cursor: pointer;" routerLink="/engagingtech">Consultants ( Technical Support)
                    </h3>
                    The engagement of Non- Training Profile Consultants (Technical
                    Support) to be engaged in RDSDEs and DGT HQRs.


                  </div>
                </div>
              </div> -->
            <!-- feature box close -->


            <!-- feature box begin -->
            <!-- <div class="col-md-6 feature-box mb40 sq-item wow">
                <div class="feature-box style-2 left">
                  <i routerLink="/jvc" class="fa fa-user"></i>
                  <div class="text">
                    <h3 style="cursor: pointer;" routerLink="/jvc">Junior Vocational Consultants </h3>
                    The engagement of Junior Vocational Consultants (JVCs) for NSTIs to take care of Training of CTS
                    courses along with New Age Courses (CTS) and High-End courses. (CTS)
                  </div>
                </div>
              </div> -->
            <!-- feature box close -->

          </div>
        </div>

        <!-- <div class="col-md-4">
        <figure class="picframe invert transparent hover-shadow rounded">
                              <span class="overlay-v">
              <span class="v-center">
                <span>
                  <a id="play-video" class="video-play-button popup-youtube" href="https://www.youtube.com/watch?v=CmCIZ_aUAeQ">
                    <span></span>
                  </a>
                </span>
              </span>
            </span>
                          <img src="assets/images/misc/2.jpg" class="img-fullwidth" alt="">
                      </figure>
      </div> -->
      </div>

    </div>
  </section>





  <div class="container">
    <h2 class="process_cls">The Process</h2>
    <hr style="border-top: solid 1px #F56B55;">
  </div>
  <!-- section begin -->
  <section id="section-services" class="cus_pad_empty">
    <div class="container">

      <div class="row align-items-center">
        <div class="col-md-12">
          <div class="row sequence">
            <!-- feature box begin -->
            <div class="col-md-12 mb40 sq-item wow sq-item wow">

              <div class="feature-box style-2 left cus_ft_box">
                <i class="icon-pencil cus_ani_icon"></i>
                <div class="text">
                  <h3>One time registration </h3>
                </div>
                <img src="assets/images/dwn_arrow.png" width="30px" />
                <!-- <i class="fa fa-arrow-down cus_arrow" aria-hidden="true" ></i> -->
              </div>

            </div>
            <div class="col-md-12 mb40 sq-item wow sq-item wow">
              <div class="feature-box style-2 left cus_ft_box">
                <i class="fa fa-list-alt cus_ani_icon" aria-hidden="true" routerLink="/vacancy"
                  routerLinkActive="router-link-active"></i>

                <div class="text">
                  <h3>Apply for job </h3>
                </div>
                <img src="assets/images/dwn_arrow.png" width="30px" />
              </div>

            </div>
            <div class="col-md-12 mb40 sq-item wow sq-item wow">
              <div class="feature-box style-2 left cus_ft_box">
                <i class="fa fa-search cus_ani_icon" aria-hidden="true"></i>
                <div class="text">
                  <h3>Application scrutiny </h3>
                </div>
                <img src="assets/images/dwn_arrow.png" width="30px" />
              </div>

            </div>
            <div class="col-md-12 mb40 sq-item wow sq-item wow">
              <div class="feature-box style-2 left cus_ft_box">
                <i class="fa fa-desktop cus_ani_icon" aria-hidden="true"></i>
                <div class="text">
                  <h3>Screening Test / Online Exam </h3>
                </div>
                <img src="assets/images/dwn_arrow.png" width="30px" />
              </div>

            </div>
            <div class="col-md-12 mb40 sq-item wow sq-item wow">
              <div class="feature-box style-2 left cus_ft_box">
                <i class="fa fa-users cus_ani_icon" aria-hidden="true"></i>
                <div class="text">
                  <h3>Shortlisting </h3>
                </div>
                <img src="assets/images/dwn_arrow.png" width="30px" />
              </div>

            </div>
            <div class="col-md-12 mb40 sq-item wow sq-item wow">
              <div class="feature-box style-2 left cus_ft_box">
                <i class="fa fa-user cus_ani_icon" aria-hidden="true"></i>

                <div class="text">
                  <h3>Final Interview </h3>
                </div>

              </div>

            </div>

            <!-- feature box close -->







          </div>
        </div>


      </div>

    </div>
  </section>



  <!-- section begin -->
  <section class="bg-color text-light pt60 pb60">
    <div class="container">

      <div class="row">
        <div class="col-md-3 col-sm-6 col-xs-6 mb-sm-30">
          <div class="de_count">
            <h3 class="timer" data-to="25" data-speed="2500">25</h3>
            <span>Institutes </span>
          </div>
        </div>

        <div class="col-md-3 col-sm-6 col-xs-6 mb-sm-30">
          <div class="de_count">
            <h3 class="timer" data-to="80">80</h3>
            <span>Vacancies</span>
          </div>
        </div>

        <div class="col-md-3 col-sm-6 col-xs-6 mb-sm-30">
          <div class="de_count">
            <h3 class="timer" data-to="05">05</h3>
            <span>Job Listings</span>
          </div>
        </div>

        <div class="col-md-3 col-sm-6 col-xs-6 mb-sm-30">
          <div class="de_count">
            <h3 class="timer" data-to="34" data-speed="2500">34</h3>
            <span>Exam Centers</span>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- section close -->

  <!-- section begin -->
  <section data-bgcolor="#f9f9f9">
    <div class="container">
      <div class="row align-items-center">

        <div class="col-md-6">
          <img src="assets/images/misc/desk_img.jpg" class="mb-sm-30 img-fluid" alt="">
        </div>

        <div class="col-md-5 offset-md-1">
          <h2 class="mb20">CBT Online Examination.</h2>
          <p>An All India CBT Exam for selection of pool of candidates will be conducted Online at NSTIs.</p>
          <div class="spacer-half"></div>
          <a href="#section-portfolio" class="btn-custom scroll-to">View Exam Centers</a>
        </div>

        <div class="clearfix"></div>
      </div>
    </div>
  </section>
  <!-- section close -->

  <div class="row notifi_main ">
    <div class="col-md-12">
      <h2>
        National Skill Training Institutes
      </h2>
    </div>
  </div>


  <!-- section begin -->
  <section id="section-portfolio" aria-label="section-portfolio" class="no-top no-bottom" data-bgcolor="#fafafa">
    <div class="container-fluid">
      <div class="row no-gutters gallery-wrap sequence_pf">

        <!-- gallery item -->
        <div class="col-lg-4 col-md-6 col-sm-6 sq-item">
          <div class="picframe wow">
            <div class="pf-click" data-value="project-details-image.html">
              <!-- <span class="overlay">
              <span class="title">
                <span>Single Image</span>
                            </span>
                            </span> -->
              <img src="assets/images/portfolio/slide_01.jpg" class="wow" alt="" />
            </div>
          </div>
        </div>
        <!-- close gallery item -->

        <!-- gallery item -->
        <div class="col-lg-4 col-md-6 col-sm-6 sq-item">
          <div class="picframe wow">
            <div class="pf-click" data-value="project-details-slider.html">
              <!-- <span class="overlay">
              <span class="title">
                <span>Multi Images Slider</span>
                            </span>
                            </span> -->
              <img src="assets/images/portfolio/slide_02.jpg" class="wow" alt="" />
            </div>
          </div>
        </div>
        <!-- close gallery item -->

        <!-- gallery item -->
        <div class="col-lg-4 col-md-6 col-sm-6 sq-item wow">
          <div class="picframe wow">
            <div class="pf-click" data-value="project-details-youtube.html">
              <!-- <span class="overlay">
              <span class="title">
                <span>Youtube Video</span>
                            </span>
                            </span> -->
              <img src="assets/images/portfolio/slide_03.jpg" class="wow" alt="" />
            </div>
          </div>
        </div>
        <!-- close gallery item -->

        <!-- gallery item -->
        <div class="col-lg-4 col-md-6 col-sm-6 sq-item">
          <div class="picframe wow">
            <div class="pf-click" data-value="project-details-image-big.html">
              <!-- <span class="overlay">
              <span class="title">
                <span>Single Image Big</span>
                            </span>
                            </span> -->
              <img src="assets/images/portfolio/slide_04.jpg" class="wow" alt="" />
            </div>
          </div>
        </div>
        <!-- close gallery item -->

        <!-- gallery item -->
        <div class="col-lg-4 col-md-6 col-sm-6 sq-item">
          <div class="picframe wow">
            <div class="pf-click" data-value="project-details-slider-big.html">
              <!-- <span class="overlay">
              <span class="title">
                <span>Multi Images Slider Big</span>
                            </span>
                            </span> -->
              <img src="assets/images/portfolio/slide_05.jpg" class="wow" alt="" />
            </div>
          </div>
        </div>
        <!-- close gallery item -->

        <!-- gallery item -->
        <div class="col-lg-4 col-md-6 col-sm-6 sq-item">
          <div class="picframe wow">
            <div class="pf-click" data-value="project-details-youtube-big.html">
              <!-- <span class="overlay">
              <span class="title">
                <span>Youtube Video Big</span>
                            </span>
                            </span> -->
              <img src="assets/images/portfolio/slide_06.jpg" class="wow" alt="" />
            </div>
          </div>
        </div>
        <!-- close gallery item -->

      </div>
    </div>
  </section>
  <!-- section close -->

  <div id="loader-area">
    <div class="container">
      <div class="project-load"></div>
    </div>
  </div>

  <!-- section begin -->
  <!-- <section id="section-blog" data-bgcolor="#f9f9f9">
        <div class="container">
            <div class="row">

                <div class="col-md-12">
                    <div id="blog-carousel" class="owl-carousel owl-theme">
                        <div class="post-item s1 item">
                            <div class="date-box">
                                <div class="m">10</div>
                                <div class="d">JUN</div>
                            </div>

                            <div class="post-content">
                                <div class="post-text">
                                    <h3><a href="#">Make Better User Interface</a></h3>
                                    <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                                </div>
                            </div>
                        </div>

                        <div class="post-item s1 item">
                            <div class="post-content">
                                <div class="date-box">
                                    <div class="m">15</div>
                                    <div class="d">JUN</div>
                                </div>

                                <div class="post-text">
                                    <h3><a href="#">Experts Web Design Tips</a></h3>
                                    <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                                </div>
                            </div>
                        </div>

                        <div class="post-item s1 item">
                            <div class="post-content">
                                <div class="date-box">
                                    <div class="m">20</div>
                                    <div class="d">JUN</div>
                                </div>

                                <div class="post-text">
                                    <h3><a href="#">Importance Of Web Design</a></h3>
                                    <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                                </div>


                            </div>
                        </div>

                        <div class="post-item s1 item">
                            <div class="post-content">
                                <div class="date-box">
                                    <div class="m">22</div>
                                    <div class="d">JUN</div>
                                </div>

                                <div class="post-text">
                                    <h3><a href="#">Avoid Erros In UI Design</a></h3>
                                    <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                                </div>
                            </div>
                        </div>

                        <div class="post-item s1 item">
                            <div class="post-content">
                                <div class="date-box">
                                    <div class="m">28</div>
                                    <div class="d">JUN</div>
                                </div>

                                <div class="post-text">
                                    <h3><a href="#">Make Your Website Faster</a></h3>
                                    <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                                </div>
                            </div>
                        </div>

                        <div class="post-item s1 item">
                            <div class="post-content">
                                <div class="date-box">
                                    <div class="m">30</div>
                                    <div class="d">JUN</div>
                                </div>

                                <div class="post-text">
                                    <h3><a href="#">Create Marketing Website</a></h3>
                                    <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </section> -->
  <!-- section close -->






  <style>
    #section-intro {
      background-image: url(assets/images/background/Nimibuilding.jpg);
      background-size: cover;
      background-position: 0% 0px;
      height: 100vh !important;
    }

    .notifi_main {
      text-align: center;
      padding: 40px 0px;
    }

    .notifi_main h2 {
      border-bottom: 6px solid #F56B55;
      width: fit-content;
      margin: 0 auto;
      padding: 0px 30px;
    }

    .notifi_main .descrip_cls {
      padding: 5px 0px;
      font-weight: 500;
      font-size: 21px;
    }

    .overlay-bg.t50 {
      background: rgba(30, 30, 30, .1);
    }

    table {
      width: 100%;
    }

    th,
    td {
      padding: 10px;
    }

    thead {
      background-color: #F56B55;
      color: #fff;
    }

    tr:nth-child(odd) {
      background-color: #eee;
    }

    .cus_ft_box {
      margin: 0 auto;
      text-align: center;
    }

    .cus_ft_box .text {
      padding-top: 10px;
    }

    .cus_arrow {
      background: transparent !important;
      color: #999;
      position: unset !important;
    }

    .cus_ani_icon {
      border-radius: 30px !important;
      position: unset !important;
      margin-bottom: 0px;
    }

    .cus_ft_box .text {
      padding-left: 0px !important;
    }

    .process_cls {
      font-size: 28px;
      background: #fff;
      position: relative;
      top: 54px;
      margin: 0 auto;
      width: fit-content;
      padding: 0px 20px;
    }

    .cus_pad_empty {
      padding: 0px;
    }
  </style>